import { isFilled } from "@prismicio/client";
import { PrismicNextImage, PrismicNextLink } from "@prismicio/next";
import { PrismicImage } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.SocialMediaSlice} SocialMediaSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<SocialMediaSlice>} SocialMediaProps
 * @type {import("react").FC<SocialMediaProps>}
 */
const SocialMedia = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}>
      <div className="flex flex-col justify-start items-start gap-4">
        {isFilled.keyText(slice.primary.section_title) && (
          <span className="text-xl">{slice.primary.section_title}</span>
        )}
        <ul className="flex flex-row justify-start items-start gap-4 list-none m-0 p-0">
          {slice.primary.ctas.length > 0 &&
            slice.primary.ctas.map((cta, index) => (
              isFilled.link(cta.cta) && isFilled.image(cta.cta_icon) && (
                <li key={index}>
                  <PrismicNextLink
                    field={cta.cta}>
                    <PrismicNextImage
                      field={cta.cta_icon}
                      className="w-12 h-12 md:w-8 md:h-8 lg:w-12 lg:h-12 rounded-full object-cover bg-beige"
                    />
                  </PrismicNextLink>
                </li>
              )
            ))
          }
        </ul>
      </div>
    </section>
  );
};

export default SocialMedia;
